// A leaf module on purpose: the request layer, the prefetch helpers and the
// pages all need to ask this, and none of them should pull in the router.

// The storefront request client is Axios-backed, so a rejected response carries
// its status. Anything without one is a network or programming failure, not a
// missing entity.
export const isNotFoundError = (error: unknown) =>
  (error as { response?: { status?: number } })?.response?.status === 404;
